import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-unlock-step',
  templateUrl: './alert-unlock-step.component.html',
  styleUrls: ['./alert-unlock-step.component.scss']
})
export class AlertUnlockStepComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
